import moment from "moment";
import React, { useEffect, useMemo } from "react";
import { ITimelineColumnProps } from "./TimelineColumn";
import { SmallBody } from "src/components/Text";
import { monthLangTags } from "../utils";
import localize from "src/l10n/localize";

const TimelineColumnMonth = (props: ITimelineColumnProps) => {
    const headerRef = React.useRef<HTMLDivElement>(null);

    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            year: m.format("YYYY"),
            monthName: localize(monthLangTags[m.month()]),
            isDecember: m.month() === 11,
            isJuly: m.month() === 6,
            isActive: m.isSame(moment(), 'month')
        }
    }, [props.item.startMilliseconds]);

    useEffect(() => {
        props.reportHeaderHeight(headerRef.current.clientHeight);
    }, [headerRef]);

    return (
        <div className="TimelineColumn" style={{
            width: props.columnWidth
        }}>
            <div ref={headerRef}>
                <div
                    className={[
                        "header-column",
                        data.isDecember ? "border-right" : "",
                    ].filter(x => !!x).join(" ")}
                    style={{
                        height: 32,
                        width: props.columnWidth,
                    }}>
                    <SmallBody>{data.isJuly && data.year}</SmallBody>
                </div>
                <div
                    className={[
                        "header-column",
                        "border-right",
                        (data.isActive ? " active" : "")
                    ].join(" ")}
                    style={{
                        width: props.columnWidth,
                        height: 36,
                    }}>
                    <div>
                        <SmallBody>{data.monthName}</SmallBody>
                    </div>
                </div>
            </div>
            <div className="border-right lane" style={{
                width: props.columnWidth,
                position: "relative"
            }}></div>
        </div>
    )
}

export default TimelineColumnMonth;
